import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IAudioProcessorTask, IAudioProcessorTaskBlock } from '../models/audio-processor-task.model';
import { IAcusticaSubscription } from '../models/acustica-subscription.model';
import { IAudioPlugin } from '../models/plugin.model';
import * as signalR from "@microsoft/signalr"

const endpoints = environment.endpoints;

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  private hubConnection!: signalR.HubConnection

  constructor(private oidcSecurityService: OidcSecurityService) {

  }

  public startConnection = (context: any) => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(endpoints["Luigi.Worker.Sevice"] + "/NotificationHub")
      .build();
    this.hubConnection
      .start()
      .then(() =>
        this.oidcSecurityService.getUserData().subscribe((data) => {
          this.hubConnection.invoke("Subscribe", data.sub);

          this.hubConnection.on('CREATE', (data) => {
            context.onCreated(data);
          });

          this.hubConnection.on('COMPLETE', (data) => {
            context.onCompleted(data);
          });

          this.hubConnection.on('ERROR', (data) => {
            context.onError(data);
          });

          this.hubConnection.on('UPDATE', (data) => {
            context.onUpdate(data);
          });
        })
      )
      .catch (err => console.log('Error while starting connection: ' + err))
  }

}

